import FolderIcon from "@mui/icons-material/Folder";
import ShareIcon from "@mui/icons-material/Share";
import PlagiarismOutlinedIcon from '@mui/icons-material/PlagiarismOutlined';

export function getFileNumberGeneratorMenus(role) {
    return [
        {
            label: 'sidebar.menu.fileNumberGenerator',
            type: "section",
            children: [
                {
                    uri: "/file-number-generator",
                    label: "sidebar.menuItem.fileNumberGenerator",
                    type: "nav-item",
                    icon: <FolderIcon sx={{fontSize: 20}}/>
                },
                {
                    uri: "/file-number-generator/my-list",
                    label: "sidebar.menuItem.fileNumberGenerator_myList",
                    type: "nav-item",
                    icon: <ShareIcon sx={{fontSize: 20}}/>
                },
                ...(role === "admin" ? [{
                    uri: "/file-number-generator/admin",
                    label: "sidebar.menuItem.fileNumberGenerator_admin",
                    type: "nav-item",
                    icon: <PlagiarismOutlinedIcon sx={{fontSize: 20}}/>
                }] : [])
            ]
        }
    ];
}